import React, { useState, useEffect } from 'react'
import Header from '../../Components/Common/Header';
import Footer from '../../Components/Common/Footer';
import { Helmet } from 'react-helmet-async';
import config from '../../config';
import { useLocation } from "react-router-dom";
import draftToHtml from 'draftjs-to-html';
import { useNavigate } from 'react-router-dom';

const BlogDetail = () => {
  const location = useLocation();
  const blogId = location.state?.blogId;
  const [blog, setBlog] = useState();
  const [recentBlog, setRecentBlog] = useState();
  const [error, setError] = useState(null);

  const formatDate = (dateString) => {
    if (!dateString) return "----"; // Check if dateString is empty or falsy

    const date = new Date(dateString);

    // Check if the date is invalid
    if (isNaN(date.getTime())) return "";

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await fetch(`${config.baseUrl}/blog/${blogId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch Blog Details');
        }
        const result = await response.json();
        console.log("Data: ", result)
        if (result.status === 'success') {
          const data = result.data;
          setBlog(data);
        } else {
          setError('No data found');
        }
      } catch (err) {
        setError(err.message);
      }
    };

    const fetchRecentBlogs = async () => {
      try {
        const response = await fetch(`${config.baseUrl}/recent-blogs`);
        if (!response.ok) {
          throw new Error('Failed to fetch Blog Details');
        }
        const result = await response.json();
        console.log("Data: ", result)
        if (result.status === 'success') {
          const data = result.data;
          setRecentBlog(data);
        } else {
          setError('No data found');
        }
      } catch (err) {
        setError(err.message);
      }
    };

    fetchBlog();
    fetchRecentBlogs();
  }, [blogId]);

  const navigate = useNavigate();
  const handleReadMore = (id, name) => {
    const slug = name.toLowerCase().replace(/\s+/g, "-");
    navigate(`/blogs/${slug}`, { state: { blogId: id } });
  };

  return (
    <>
      {/* For Dynamically adding Meta Data */}
      {blog && (
        <Helmet>
          <title>{blog.meta_title}</title>
          <meta name="description" content={blog.meta_description} />
        </Helmet>
      )}

      <Header />
      <div className='common-banenr'>
        <div className='common-content'>
          <h1>Blog</h1>
        </div>
      </div>
      {/* ---------------------- */}
      <div className="blogdetailpage">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="blogdetailcontent">
                <h4 className="card-title">
                  <p className="text-dark fw-bolder">{blog?.name}</p>
                </h4>
                <div className="meta">
                  {`By ${blog?.writer_name}`} <span>-{formatDate(blog?.created_at)}</span>
                </div>
                <div className="blogdetailimage">
                  <img src={`${config.imgURL}/data/uploads/${blog?.image}`} alt="" />
                </div>
                {blog?.description && (() => {
                  try {
                    return (
                      <div dangerouslySetInnerHTML={{ __html: blog?.description }}/>
                    );
                  } catch (err) {
                    console.error("Failed to render blog description:", err);
                    return <p className="text-danger">Could not load blog content.</p>;
                  }
                })()}
              </div>
            </div>
            {/* Recent Blogs and Search */}
            <div className="col-md-4">
              <div className="recentblogs">
                <h4>Recent Blogs </h4>
                <ul>
                  {recentBlog && recentBlog.map((item, index) => (
                    <li key={index}>
                       <button className="red" onClick={() => handleReadMore(item.id, item.name)}>
                       {item.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------------------- */}
      <Footer />
    </>
  )
}

export default BlogDetail

